// extracted by mini-css-extract-plugin
export var textInput = "_id-0";